import { Button, RiArrowDownSLine } from "@itandi/itandi-bb-ui";
import type React from "react";

export const renderDropDownButton = (label: string): React.ReactElement => (
	<Button
		endIcon={<RiArrowDownSLine />}
		height="small"
		type="button"
		variant="secondary"
	>
		{label}
	</Button>
);
